import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
// import { activeLayers } from "./mapGIS";
import "./ClearLayersButton.css";
import Tooltip from "@mui/material/Tooltip";
import { act } from "react-dom/test-utils";

const ClearLayersButton = ({
  setCheckedAll,
  checkedAll,
  setSwitchIsOn,
  activeLayers,
  layersThatWereSwitchedNames,
  setActiveLayers,
  setLayersThatWereSwitchedNames,
  setLayerName,
  setClearLayersWasClicked,
}) => {
  /**
   * This function sets all acive layers and their switches to null and clears the layers to be switched array
   */
  const toggleLayerRemover = () => {
    console.log("click registered");
    console.log(activeLayers, "activeLayers");

    activeLayers.forEach((name) => {
      setSwitchIsOn(false);
      const removeLayerSource = (layerName) => {
        const layerExists = window.map.getLayer(`${layerName}-layer`);
        const sourceExists = window.map.getSource(`${layerName}-source`);

        if (layerExists && sourceExists) {
          window.map.removeLayer(`${layerName}-layer`);
          window.map.removeSource(`${layerName}-source`);
          console.log(`${layerName} layer removed apo to clear layers button`);
        }
      };
      removeLayerSource(name);
    });
    setLayerName("removeAll");
    setCheckedAll(false);
    setActiveLayers([]);
    setLayersThatWereSwitchedNames([]);
    setClearLayersWasClicked(true);
    // setLayerName(null);

    console.log(activeLayers, "activeLayers meta to wipe");
  };

  return (
    <div className="button-clear-container" id="removelayers-button">
      <Tooltip
        title={
          <span style={{ fontSize: "14px" }}>
            <b>Clear All Layers</b>
          </span>
        }
        placement="right"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "rgba( 83, 139, 34, 0.9)",
              fontFamily: "Maven pro",
              padding: "5px 10px",
              "& .MuiTooltip-arrow": {
                color: "rgba( 83, 139, 34, 0.9)",
              },
            },
          },
        }}
      >
        <button
          className="layer-layer-show"
          onClick={() => {
            {
              toggleLayerRemover();
            }
          }}
        >
          <FontAwesomeIcon icon={faBroom} />
        </button>
      </Tooltip>
    </div>
  );
};
export default ClearLayersButton;
